module.exports = __webpack_public_path__ + "static/media/shortUShortOOTest.0d3ffae8.mp3";